import {
  useTripsStyles,
  useModuleBEM,
  useTenantImages,
} from "@b2bportal/core-themes";
import { CoreTripsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PageLoadingScreen } from "@tenant/ui";
import defaultStyles from "./LoadingScreen.module.scss";

export interface LoadingScreenProps {
  isLoading?: boolean;
}
export const LoadingScreen = ({ isLoading }: LoadingScreenProps) => {
  const styles = useTripsStyles(
    CoreTripsComponent.TripListLoadingScreen,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreTripsComponent.TripListLoadingScreen
  );

  const { t } = useI18nContext();

  const images = useTenantImages();

  return (
    <PageLoadingScreen
      isLoading={isLoading}
      backgroundImage={images?.tripsLoadingImage}
      className={block}
      text={t("fetchingTrips")}
    />
  );
};
